import { useEffect, useRef } from 'react';
import { throttle } from 'lodash-es';
import { INewsDataLocaleItem } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/SteamNewsAndAnnouncements';

interface IUseLoadMore {
  newsData: { [key: string]: INewsDataLocaleItem[] };
  currentSegment: string;
  hasMoreRef: { current: boolean };
  getSteamNewData: (params: {
    isFetchMore?: boolean;
    isAll?: boolean;
    isOthers?: boolean;
    eventType: string;
  }) => Promise<void>;
}

export const useLoadMore = ({
  newsData,
  currentSegment,
  hasMoreRef,
  getSteamNewData,
}: IUseLoadMore) => {
  const isFetchingRef = useRef(false);

  // 加载更多
  const handleLoadMore = async () => {
    if (!hasMoreRef.current || isFetchingRef.current) return;

    const isAll = currentSegment === 'all';
    const isOthers = currentSegment === 'others';
    isFetchingRef.current = true;
    try {
      await getSteamNewData({ isFetchMore: true, isAll, isOthers, eventType: currentSegment });
    } catch (error) {}
    isFetchingRef.current = false;
  };

  const handleScroll = throttle(
    () => {
      const scrollContainer = document.querySelector('.dbi-topcharts-detail');
      if (scrollContainer) {
        const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
        if (scrollHeight - scrollTop - clientHeight <= 100) {
          handleLoadMore();
        }
      }
    },
    200,
    { leading: false, trailing: true },
  );

  useEffect(() => {
    const scrollContainer = document.querySelector('.dbi-topcharts-detail');

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
    }

    return () => {
      scrollContainer?.removeEventListener('scroll', handleScroll);
    };
  }, [newsData, currentSegment]);
};
